
var previousPageFlag=false;
var dummyFlag=false;
class CollectionFilters extends HTMLElement {
  constructor() {
    super();
    this.accordionType = this.dataset.accordiontype;
    this.filterParent = this.closest('#filtersCollapse');
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.filterForm = this.querySelector('form');
    this.quickshop = document.querySelector('quick-shop');
    this.filterType = this.dataset.filtertype;

    const toggleBtns = this.querySelectorAll('.filter__toggle');
    toggleBtns.forEach(button => button.addEventListener('click', this.toggleFilterBlock.bind(this)));

    /*********** Open Drawer on Filter or SortBy button click. Close Drawer on close button click *************/
    this.openFilterDrawer = document.getElementById('filter-drawer');
    if(this.openFilterDrawer) this.openFilterDrawer.addEventListener('click', this.toggleFilterDrawer.bind(this));

    this.openSortbyDrawer = document.getElementById('sortby-drawer');
    if(this.openSortbyDrawer) this.openSortbyDrawer.addEventListener('click', this.toggleFilterDrawer.bind(this));

    this.closeFilterDrawer = this.filterParent.querySelector('.collection-filters-close');
    if(this.closeFilterDrawer) this.closeFilterDrawer.addEventListener('click', this.toggleFilterDrawer.bind(this));

    if(this.filterType == 'horizontal-filters'){
      document.body.addEventListener('click', (event)=>{
        const openFilters = document.querySelectorAll('.filter__container.open');
        openFilters.forEach((target) => {
          target.querySelector('.filter__toggle').click();
        })
      });
      const filterContainers = document.querySelectorAll('.filter__container');
      filterContainers.forEach((target) => {
        target.addEventListener('click', (event)=>{
          event.stopPropagation();
        });
      });
    }
    /*********** End of Open Drawer on Filter or SortBy button click. Close Drawer on close button click ********/

    this.sortby_values = document.querySelectorAll('[data-sortby] .sortby_options');
    this.sortby_values.forEach(input => input.addEventListener('change', this.updateSortBy.bind(this)));

    this.subCollectionLinks = document.querySelectorAll('[data-subCollections] .collection-entry');
    this.subCollectionLinks.forEach(link => link.addEventListener('click', this._manageSubCollections.bind(this)));

    this.filterParent.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE'){ this.closeFilterDrawer.dispatchEvent(new Event('click')); }
    });

    this.debouncedOnSubmit = Utility.debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    if(this.filterForm){
       this.filterForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
      this.filterForm.addEventListener('submit', this.debouncedOnSubmit.bind(this));
      window.addEventListener('popstate', this.onHistoryChange.bind(this));
    }

    const applyBtn = this.querySelector('[data-applyFilters]');
    if(applyBtn){
      
      applyBtn.addEventListener('click', () => {
        this.filterForm.dispatchEvent(new Event('submit', {'bubbles' : true, 'cancelable' : true }));
        setTimeout(() => {
          this.closeFilterDrawer.dispatchEvent(new Event('click'));
        }, 200);
      });
    }

    const paginationLinks = document.querySelectorAll('[data-pagination]');
    paginationLinks.forEach(link => link.addEventListener('click', this._managePagination.bind(this)));

    const paginationBackLinks = document.querySelectorAll('[data-back-pagination]');
    paginationBackLinks.forEach(link => link.addEventListener('click', this._manageBackPagination.bind(this)));

    this.bindActiveFilterButtonEvents();
    this.addAccessibilityAttributes(toggleBtns);
    this.colorOptionsStyling();

    this._scrollToProduct();
    this.loadSubitems()
    this.checkCards();

    previousPageFlag=false;
  }

  /**
   * Filter Block Toggle event
   * @param {NodeList} toggleBtns Open filter block buttons
   */
  addAccessibilityAttributes(toggleBtns) {
    toggleBtns.forEach(element => {
      element.setAttribute('role', 'button');
      element.setAttribute('aria-expanded', false);
      element.setAttribute('aria-controls', element.nextElementSibling.id);
    });
  }

  _scrollToProduct() {
    document.querySelectorAll('[data-pr-id]').forEach(ele => {
      ele.addEventListener('click',(event)=>{
        let prId=ele.getAttribute('data-pr-id');
        localStorage.setItem('prId',prId);
      })
    });

    if (localStorage.getItem('prId')) {
      let prHeight=document.querySelector(`[data-pr-Id="${localStorage.getItem('prId')}"]`)?.offsetTop;
      window.scrollTo({ top: parseFloat(prHeight), behavior: 'smooth' });
      localStorage.removeItem('prId')
    }

    let sTimeOut=0
    if (!dummyFlag) {
      sTimeOut=200
    }
    window.addEventListener('scroll',(event)=>{
      event.stopImmediatePropagation();
      setTimeout(() => {
        if (!previousPageFlag && Utility.in_Viewport(document.querySelector('#prev-load-more')) && document.querySelector('#prev-load-more') != null) {
          previousPageFlag=true;
          
            document.querySelector('#prev-load-more')?.click();
            document.querySelector('#prev-load-more').style.pointerEvents="none";
            dummyFlag=true;
        }
      },sTimeOut)
    })
  }

  loadSubitems() {
    document.querySelectorAll('.is-subitem').forEach(subitem => {
      subitem.classList.remove('is-subitem-active');
    });
    document.querySelectorAll('.form-check-input:checked').forEach(filter => {
      document.querySelectorAll(`.group-${filter.value}`).forEach(subitem => {
          subitem.classList.add('is-subitem-active');
      });
    });
  }
  checkCards() {
    if (location.search) {
      document.querySelectorAll('.collection-infocard').forEach(card => card.classList.add("d-sm-none", "d-md-none", "d-lg-none", "d-xl-none"));
    } else {
      document.querySelectorAll('.collection-infocard').forEach(card => card.classList.remove("d-sm-none", "d-md-none", "d-lg-none", "d-xl-none"));
    }
  }
  /**
   * Collection filter form Input event
   * @param {event} event Event Instance
   */
  onSubmitHandler(event) {
    event.preventDefault();
    //if(event.type == 'input' && this.filterParent.classList.contains('filter-active')){
      //return;
    //}
    if (!event.target.checked) {


      document.querySelectorAll(`.group-${event.target.value}`).forEach(subitem => {


        subitem.querySelector('input').checked = false;


      });


    }
    let closestForm = document.getElementById('CollectionFiltersForm');
    if(event.target && event.target.closest('form')){ closestForm = event.target.closest('form'); }
    if(!closestForm) return;

    const searchParams = this._finalQueryString(closestForm)
    this.renderPage(searchParams, event);
  }

  /**
   * click event To Remove current selections
   * @param {element} form Collection page filter form
   */
  _finalQueryString(form){
    const formData = new FormData(form);
    let searchParams = '';
    let constraints = '';
    formData.forEach((val, key) => {
      if(key.indexOf('price-list') >= 0){
        searchParams += '&' + val;
      }else if(key.indexOf('custom_sort_by') >= 0){
        //  Code for SortBy
      }else if(key.indexOf('tagsFilter-') > -1){
        if(constraints === ''){ constraints = val; }
        else{ constraints += `+${val}`; }
      }else if(val != null && val.length > 0){
        if(searchParams === ''){ searchParams = key + '=' + val;}
        else{ searchParams += '&' + key + '=' + val; }
      }
    });

    if(constraints != ''){
      if(searchParams == ''){
        searchParams = `?constraint=${constraints}`;
      }else{
        searchParams += `&constraint=${constraints}`;
      }
    }

    return searchParams;
  }

  /**
   * Add background color in label of Color options
   */
  colorOptionsStyling(){
    const colorSwatchContainer = this.querySelector('[data-colorFilter]');
    if(colorSwatchContainer){
      const colorSwatches = colorSwatchContainer.querySelectorAll('.color-options');
      colorSwatches.forEach(swatch => {
        let colorHandle = swatch.querySelector('input[type="checkbox"]').dataset.handle;
        let swatchStyle = Utility.getSwatchStyle(colorHandle);
        swatch.querySelector('.option-label').setAttribute('style', swatchStyle);
      });
    }
  }

  /**
   * click event To Remove current selections
   * @param {event} event Event Instance
   */
   onActiveFilterClick(event) {
    event.preventDefault();
    let currentTarget = event.target;
    let URLString = null;
    if(currentTarget.dataset.type == 'tag_based'){
      const inputValue = currentTarget.dataset.remove;
      const inputElement  = document.querySelector(`input[data-tagslist][value="${inputValue}"]`);
      if(inputElement) inputElement.checked = false;

      let closestForm = document.getElementById('CollectionFiltersForm');
      if(!closestForm) return;
      URLString = this._finalQueryString(closestForm);
    }else{
      if(!currentTarget.classList.contains('filter-option-clear')){ 
        currentTarget = event.target.closest('.filter-option-clear');
        URLString = new URL(currentTarget.href).searchParams.toString();
      };
    }
    if(URLString != null)
      this.renderPage(URLString);
  }

   /**
   * Update Window URL as per active filters
   * @param {event} event Event Instance
   */
  onHistoryChange(event) {
    const searchParams = event.state?.searchParams || '';
    this.renderPage(searchParams, null, false);
  }

  renderPage(searchParams, event, updateURLHash = true) {
    event.stopImmediatePropagation();
    document.getElementById('collection-product-grid').querySelector('#template-collection').classList.add('loading');

    const url = `${window.location.pathname}?${searchParams}`;
    this.renderGridFromFetch(url, 'filter');

    if (updateURLHash) this.updateURLHash(searchParams);
  }

  renderGridFromFetch(url, type) {
    document.querySelector('.collection-filter-grid').classList.add('is-loading');
    if(!url) return;
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        this.renderProductGrid(html, type);
      });
  }

  renderProductGrid(html, type) {
    const innerHTML = new DOMParser().parseFromString(html, 'text/html');
    let infocardElements = document.querySelectorAll('.collection-infocard');
    if (document.querySelector('#prev-load-more') != null) {
      document.querySelector('#prev-load-more').style.pointerEvents="all";
      previousPageFlag=false;
    }
    let paginationType = 'numbers';
    if(document.querySelector('[data-pagination]')){
      paginationType = document.querySelector('[data-pagination]').dataset.type || 'numbers';
    }
    if(type == 'filter' || type == 'sub_collection_filter'){
      const gridHTML = innerHTML.getElementById('collection-product-grid').innerHTML;
      document.getElementById('collection-product-grid').innerHTML = gridHTML;

      if(type == 'sub_collection_filter'){
        let bannerHTML = innerHTML.querySelector('[data-collectionBanner]').innerHTML;
        document.querySelector('[data-collectionBanner]').innerHTML = bannerHTML;
      }
    }else{
      if (window.isPrevPagination !== undefined && window.isPrevPagination == true) {
        if(paginationType == 'loadmore'){
          let productGrids = innerHTML.getElementById('template-collection').innerHTML;
          let loadMoreBtn =  innerHTML.querySelector('#prev-load-more');
          (innerHTML.querySelector('#prev-load-more') != null) && innerHTML.querySelector('#prev-load-more').remove();
          document.getElementById('template-collection').insertAdjacentHTML('afterbegin', productGrids);
          if(loadMoreBtn && document.querySelector('#prev-load-more')){ 
            document.querySelector('#prev-load-more').parentNode.replaceChild(loadMoreBtn, document.querySelector('#prev-load-more')); 
          }
          else if(document.querySelector('#prev-load-more')){ document.querySelector('#prev-load-more').remove(); }
        }else{
          const gridHTML = innerHTML.getElementById('collection-product-grid').innerHTML;
          document.getElementById('collection-product-grid').innerHTML = gridHTML;
        }
        window.isPrevPagination = false;
      }else{
        if(paginationType == 'loadmore'){
          let productGrids = innerHTML.getElementById('template-collection').innerHTML;
          let loadMoreBtn =  innerHTML.getElementById('load-more');
          if(innerHTML.querySelector('#prev-load-more') != null) innerHTML.querySelector('#prev-load-more').remove();
          document.getElementById('template-collection').insertAdjacentHTML('beforeend', productGrids);
          if(loadMoreBtn && document.getElementById('load-more')){ 
            document.getElementById('load-more').parentNode.replaceChild(loadMoreBtn, document.getElementById('load-more')); 
          }
          else if(document.getElementById('load-more')){ document.getElementById('load-more').remove(); }
        }else{
          const gridHTML = innerHTML.getElementById('collection-product-grid').innerHTML;
          document.getElementById('collection-product-grid').innerHTML = gridHTML;
        }
      }
      if (infocardElements.length > 0) {
        let gridContainer = document.getElementById('collection-product-grid');
        if (gridContainer) {
            infocardElements.forEach(infocard => {
                gridContainer.insertAdjacentElement('afterbegin', infocard);
            });
        }
      }
    }

    const openFilters = document.querySelectorAll('.filter__container.open');
    const filterInnerHTML = innerHTML.getElementById('main-collection-filters').innerHTML;
    document.getElementById('main-collection-filters').innerHTML = filterInnerHTML;

    if(this.filterType != 'horizontal-filters'){
      // reopen filter blocks which are active before HTML update
      openFilters.forEach(openFilter => {
        if(openFilter.querySelector('.filter__toggle')){
          openFilter.querySelector('.filter__toggle').setAttribute('aria-expanded', true);
        }
        let filterBlock = document.querySelector('.filter__container[data-index="'+openFilter.dataset.index+'"]');
        filterBlock.classList.add('open');
        filterBlock.querySelector('.filter__block').classList.add('open');
      });
    }

    const filterContainers = document.querySelectorAll('.filter__container');
    filterContainers.forEach(filter => {
      const tagList = filter.querySelectorAll('.filter__item');
      if(tagList.length <= 0){
        filter.classList.add('d-none');
        filter.style.display = 'none';
      }
    });
    
    const totalProducts = innerHTML.querySelector('[data-totalProducts]');
    let filteredProductCount;
    if (totalProducts != "" && totalProducts != null) {
      if (totalProducts.querySelectorAll("[product-count]").length > 0) {
        filteredProductCount = totalProducts.querySelector("[product-count]");
        filteredProductCount = filteredProductCount.innerHTML;
      filteredProductCount = filteredProductCount.replace("Results found","");
      }
       
      
    }
    let productCount = document.querySelectorAll("[data-product-grid]").length;
    // if(totalProducts) document.querySelector('[data-totalProducts]').innerHTML = totalProducts.innerHTML;
    if(totalProducts) document.querySelector('[data-totalProducts]').innerHTML =`Showing  ${productCount} of ${filteredProductCount}` ;

    const activeFilters = innerHTML.querySelector('[data-activeFilters]');
    if(activeFilters) document.querySelector('[data-activeFilters]').innerHTML = activeFilters.innerHTML;
    this.bindActiveFilterButtonEvents();
    if(this.quickshop){this.quickshop.updateEvents();}
    this._scrollToProduct();
    this.loadSubitems();
    this.checkCards();
    document.querySelector('.collection-filter-grid').classList.remove('is-loading');
    this.initYotpo();

  }

  bindActiveFilterButtonEvents() {
    document.querySelectorAll('.filter-option-clear').forEach((element) => {
      element.addEventListener('click', this.onActiveFilterClick, { once: true });
    });
  }

  updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  updateSortBy(event){
    let _this = event.currentTarget;
    // let currentvalue = document.querySelector('[data-sortby] [name="custom_sort_by_mobile"]:checked').value;
    let currentvalue =  '';
    if(_this.name == 'custom_sort_by_desktop'){
      currentvalue = document.querySelector('[data-sortby] [name="custom_sort_by_desktop"]:checked').value;
    }

    this.querySelector('[name="sort_by"]').value = currentvalue;
    this.querySelector('[name="sort_by"]').dispatchEvent(new Event('input', {
      bubbles: true,
      cancelable: true,
    }));
  }

  _manageSubCollections(event){
    event.preventDefault();
    const _this =  event.currentTarget;
    let closestForm = document.getElementById('CollectionFiltersForm');
    if(_this.closest('form')){ closestForm = event.target.closest('form'); }
    const queryString = this._finalQueryString(closestForm);

    let collURL = _this.href + '?' + queryString;
    this.renderGridFromFetch(collURL, 'sub_collection_filter');
    setTimeout(() => {
      history.pushState({}, '', collURL);
    }, 200);
  }

  _managePagination(event){
    event.preventDefault();
    event.stopImmediatePropagation();
    let _this = event.currentTarget;
    const nextPageLink = _this.href;
    this.renderGridFromFetch(nextPageLink, 'pagination');

    setTimeout(() => {
      history.pushState({}, '', nextPageLink);
    }, 200);
  }

  _manageBackPagination(event){
    event.preventDefault();
    event.stopImmediatePropagation();
    let _this = event.currentTarget;
    const prevPageLink = _this.href;
    this.renderGridFromFetch(prevPageLink, 'pagination');
    window.isPrevPagination = true;

    setTimeout(() => {
      history.pushState({}, '', prevPageLink);
    }, 200);
  }

  toggleFilterDrawer(event){
    event.preventDefault();
    let button = event.currentTarget;
    if(button.id == 'filter-drawer' || button.id == 'sortby-drawer'){
      this.filterParent.classList.add('filter-active');
      button.setAttribute('aria-expanded', true);
      button.setAttribute('tabindex', '-1');

      if(button.id == 'sortby-drawer'){ this.filterParent.classList.add('sortby-drawer'); }
      else{ this.filterParent.classList.remove('sortby-drawer'); }

      Utility.trapFocus(this.filterParent);
      Utility.forceFocus(this.closeFilterDrawer);
      siteOverlay.prototype.showOverlay();
    }else{
      this.filterParent.classList.remove('filter-active');
      this.filterParent.classList.remove('sortby-drawer');
      if(this.openFilterDrawer){
        this.openFilterDrawer.setAttribute('aria-expanded', false);
        this.openFilterDrawer.removeAttribute('tabindex');
      }if(this.openSortbyDrawer){
        this.openSortbyDrawer.setAttribute('aria-expanded', false);
        this.openSortbyDrawer.removeAttribute('tabindex');
      }

      Utility.removeTrapFocus(this.filterParent);
      siteOverlay.prototype.hideOverlay();
    }
  }

  toggleFilterBlock(event) {
    event.preventDefault();
    const toggleFilterBtn = event.currentTarget;
    const filterContainer = toggleFilterBtn.parentNode;
    const isOpen = filterContainer.classList.contains('open');
    isOpen ? this.closeFilterBlock(toggleFilterBtn) : this.openFilterBlock(toggleFilterBtn);
  }

  openFilterBlock(toggleFilterBtn){
    let filterContainer = toggleFilterBtn.parentNode;
    toggleFilterBtn.setAttribute('aria-expanded', true);
    Utility.toggleElement(filterContainer, 'open');
    if(this.accordionType == 'single'){
      let siblingBlocks = filterContainer.parentNode.querySelectorAll('.filter__container');
      siblingBlocks.forEach(element => {
        if(element == filterContainer){ return; }
        element.classList.remove('open');
        element.querySelector('.filter__block').classList.remove('open');
        element.querySelector('.filter__toggle').setAttribute('aria-expanded', false);
      });
    }
    Utility.trapFocus(filterContainer);
  }

  closeFilterBlock(toggleFilterBtn){
    const filterContainer = toggleFilterBtn.parentNode;
    toggleFilterBtn.setAttribute('aria-expanded', false);
    Utility.toggleElement(filterContainer, 'close');
    Utility.removeTrapFocus(filterContainer);
  }


  initYotpo() {
  try {
    if (window.yotpo && typeof window.yotpo.refreshWidgets === 'function') {
      window.yotpo.refreshWidgets();
      return;
    }
    if (window.yotpo && typeof window.yotpo.initWidgets === 'function') {
      const container = document.getElementById('collection-product-grid') || document;
      window.yotpo.initWidgets(container);
      return;
    }
    if (window.Yotpo && window.yotpo) {
      try { new Yotpo.API(window.yotpo).refreshWidgets(); } catch(e){}
    }
  } catch (e) {
    console.warn('Yotpo re-init failed:', e);
  }
}

}

customElements.define('collection-filters', CollectionFilters);

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));

    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);
